import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Order } from '../../../common/model/dto/order/order';
import { OrderDataUtils } from '../../../common/utils/services/order-data-utils';
import StringUtils from '../../../common/utils/services/string-utils';
import breakpoints from '../../../design-system/breakpoints';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvOrderIdentityProps {
  order: Order;
  detailsPath: string;
}

const OvOrderIdentity: FC<OvOrderIdentityProps> = ({ order, detailsPath }) => {
  const { t } = useTranslation();
  const stripePaymentUrl = OrderDataUtils.getStripePaymentUrl(order);

  return (
    <>
      <IdLink to={detailsPath}>
        {StringUtils.displayValue(order.internal_id)}
      </IdLink>
      {stripePaymentUrl && (
        <Secondary>
          <a href={stripePaymentUrl} target="_blank" rel="noopener noreferrer">
            {t('orders.stripePaymentLink')}
          </a>
        </Secondary>
      )}
      {order.impact_click_id && <Tag>{t('orders.affiliate')}</Tag>}
    </>
  );
};

export default OvOrderIdentity;

const IdLink = styled(NavLink)`
  color: ${Colours.OV_BASE};
  white-space: nowrap;
  text-underline-offset: 3px;

  @media (max-width: ${breakpoints.lg}) {
    white-space: normal;
    overflow-wrap: anywhere;
  }

  &:hover {
    color: ${Colours.OV_ACCENT_BLUE};
  }
`;

const Secondary = styled.span`
  display: block;
  margin-top: 0.25rem;
  font-size: ${Variables.fontSizes.SMALL};
  font-weight: normal;

  a {
    color: ${Colours.OV_BASE};
    text-underline-offset: 3px;
  }

  a:hover {
    color: ${Colours.OV_ACCENT_BLUE};
  }
`;

const Tag = styled.span`
  display: table;
  margin-top: 0.1875rem;
  padding: 0.125rem 0.375rem;
  border-radius: ${Variables.borderRadius.SMALL};
  background-color: ${Colours.OV_BORDER_COLOR_V3};
  font-size: ${Variables.fontSizes.SMALL};
  font-weight: normal;
`;
